'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var graphqlTag = require('graphql-tag');

var retailerSettingsQuery = settingsRequested => graphqlTag.gql`
    query GetRetailerSettings(
      $product: String!
      $retailerMoniker: String!
      $versionName: String!
      $localeLanguage: Language
      $localeCountry: Country
      $bannerName: String
      $status: String
      $category: String
      $type: String
      $cache: Boolean
    ) {
      retailerSettings(
        product: $product
        retailerMoniker: $retailerMoniker
        versionName: $versionName
        localeLanguage: $localeLanguage
        localeCountry: $localeCountry
        bannerName: $bannerName
        status: $status
        category: $category
        type: $type
        cache: $cache
      ) {
        ${settingsRequested}
      }
    }
  `;

exports["default"] = retailerSettingsQuery;
